import React from 'react';
import { Box, Typography } from '@mui/material';
import Button from '../../../../components/Button/Button';
import { useStyles, getButtonStyle } from './styles';
import { useTranslation } from 'react-i18next';
import { useCategoriesContext } from '../../../../context/CategoriesContext';
import { LANG_TEXT } from '../../../../constants/language';

interface TableToolbarProps {
  onOpenMoveModal: () => void;
  onOpenManageModal: () => void;
}

const TableToolbar: React.FC<TableToolbarProps> = ({ onOpenMoveModal, onOpenManageModal }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedIds } = useCategoriesContext();

  const hasSelection = selectedIds.length > 0;

  return (
    <Box className={classes.Toolbar}>
      <Typography fontSize={18} fontWeight={600} lineHeight={'28px'} color={'var(--Gray-900, #101828)'}>
        {t(`${LANG_TEXT.MANAGE_CATEGORIES}`)}
      </Typography>
      <Box className={classes.BulkActions}>
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Typography fontSize={16} fontWeight={400} lineHeight={'24px'} color={'var(--Gray-900, #101828)'}>
            {t(`${LANG_TEXT.BULK_ACTIONS}`)}
          </Typography>
          <Typography fontSize={18} fontWeight={400} lineHeight={'24px'} color={'var(--Gray-900, #101828)'}>
            {t(`${LANG_TEXT.BULK_ACTIONS_DESCRIPTION}`)}
          </Typography>
        </Box>
        <Button
          id="categories_management"
          fullWidth={false}
          title={`${t(`${LANG_TEXT.MOVE_TO_CATEGORY}`)}`}
          buttonStyle={getButtonStyle('#30893C', hasSelection)}
          sxTextStyle={{ color: hasSelection ? '#fff' : '#9CA3AF', fontWeight: 600, fontSize: 14 }}
          boxStyle={{ width: 'max-content !important' }}
          onClick={hasSelection ? onOpenMoveModal : undefined}
          disable={!hasSelection}
        />
        <Button
          id="categories_management"
          fullWidth={false}
          title={`+ ${t(`${LANG_TEXT.CATEGORIES_MANAGEMENT}`)}`}
          buttonStyle={getButtonStyle('#F2FBF3', true)}
          sxTextStyle={{ color: '#296C32', fontWeight: 600, fontSize: 14 }}
          boxStyle={{ width: 'max-content !important' }}
          onClick={onOpenManageModal}
        />
      </Box>
    </Box>
  );
};

export default TableToolbar;
